export async function sendCommandFlex8(descricao, action) {
    const url = 'https://terrazza.cmd-automacao.com/comandoFlex8'; 
  
    const data = {
        descricao: descricao,
        action: action.status,
        idx: action.idx,
        modulo: action.modulo
    };
  
    console.log('Dados enviados:', data);
  
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        const responseData = await response.json();
        console.log('Resposta do servidor:', responseData);
    } catch (error) {
        console.error('Erro:', error);
    }
  }